var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'react-emotion';
import { usePrice } from '@jetshop/core/hooks/usePrice';
const Wrapper = styled('div') ``;
const NormalPrice = styled('div') ``;
const OldPrice = styled('div') `
  text-decoration: line-through;
`;
const NewPrice = styled('div') ``;
const PriceComponent = (_a) => {
    var { className, style } = _a, props = __rest(_a, ["className", "style"]);
    const { hasDiscount, formattedPricing } = usePrice(props);
    return (React.createElement(Wrapper, Object.assign({ className: className, style: style }, props), hasDiscount ? (React.createElement(React.Fragment, null,
        React.createElement(NewPrice, { className: "new-price" }, formattedPricing.price),
        React.createElement(OldPrice, { className: "old-price" }, formattedPricing.previousPrice))) : (React.createElement(NormalPrice, { className: "price" }, formattedPricing.price))));
};
PriceComponent.Wrapper = Wrapper;
PriceComponent.Normal = NormalPrice;
PriceComponent.Old = OldPrice;
PriceComponent.New = NewPrice;
export default PriceComponent;
//# sourceMappingURL=Price.js.map